<mat-label class="subHeading">Model</mat-label>
<mat-select class="model" formControlName="model" placeholder="All">
    <mat-option *ngFor="let modelObj of modelList" [value]="modelObj.rb_id">
        {{modelObj.model_name}}
    </mat-option>
</mat-select>